module.exports = __webpack_public_path__ + "img/online-tutor-600x450.4ba0a5d6.jpg";